export default __webpack_public_path__ + "static/media/labResult.9f7ff791.png";